import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { RoutesEnum } from '@ui-core/enums/routes.enum'
import { UserRolesConditionEnum } from '@ui-core/enums/user-roles.enum'
import { UserService } from '@ui-core/services/user.service'
import { AuthGuardData, createAuthGuard } from 'keycloak-angular'

const isAccessAllowed = async (
    route: ActivatedRouteSnapshot,
    _: RouterStateSnapshot,
    authData: AuthGuardData
): Promise<boolean | UrlTree> => {
    const { authenticated } = authData
    const userService = inject(UserService)
    const router = inject(Router)

    let routePermissions = route.data['permission'] || { roles: [], condition: 'all' }

    if (!authenticated) {
        return false
    }

    if (route.children.length > 0) {
        routePermissions = route.children[0].data['permission'] || { roles: [], condition: 'all' }
    }

    if (routePermissions.roles.length === 0) {
        return true
    }

    if (routePermissions.condition === UserRolesConditionEnum.Any) {
        if (userService.hasAnyRole(routePermissions.roles)) {
            return true
        }
    }

    if (routePermissions.condition === UserRolesConditionEnum.All) {
        if (userService.hasRoles(routePermissions.roles)) {
            return true
        }
    }

    router.navigate([RoutesEnum.FORBIDDEN])
    return false
}

export const AuthGuard = createAuthGuard<CanActivateFn>(isAccessAllowed)
